<template>
  <div class="main">
    <a-spin class="load" v-show="loading"/>
    <!--    <div class="top">-->
    <!--      <span class="icon"-->
    <!--            @click="history"><img class="goHistory"-->
    <!--             src="../../../assets/image/08.png"-->
    <!--             alt=""></span>-->
    <!--      <span class="iconText">备课资源</span>-->
    <!--    </div>-->
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/titleAnalysis'">标题解析</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">备课资源</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content">
      <a-tabs default-active-key="1"
              @change="callback">
        <a-tab-pane key="1"
                    tab="系统资源">
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="listData">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <img class="xt-Img" :src="xtImg" alt=""/>
                        <span class="class-name">素养植根专家团队</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                        <!-- <span v-if="item.objectType==1"
                              class="sysRec">* 系统推荐</span> -->
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo" @click="use(item)" :disabled="item.selected==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                    <div class="prepare-content">
                      <p v-html="item.commentContent"></p>
                    </div>
                  </div>
                  <!-- <a-avatar class="avatar"
                            slot="avatar"
                            :src="$userINfoBasePath+'/'+item.photo" /> -->
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
          <div style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2"
                    tab="优质资源"
                    force-render>
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="listDatas">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name">{{ item.userName }}</span>
                        <span class="class-name">{{ item.school }}</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                      <span v-if="item.objectType==1"
                            class="sysRec">✨ 系统推荐</span>
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="use(item)"
                                  :disabled="item.selected2==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                    <div class="prepare-content">
                      <p v-html="item.commentContent"></p>
                    </div>
                  </div>
                  <a-avatar class="avatar" slot="avatar"
                            :src="item.photo!=null?$userINfoBasePath+'/'+item.photo:'@/assets/imgs/teacher.png'"/>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
          <div style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="用户资源">
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="listDatas_use">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name">{{ item.userName }}</span>
                        <span class="class-name">{{ item.school }}</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                      <span v-if="item.objectType==1"
                            class="sysRec">✨ 系统推荐</span>
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="use(item)"
                                  :disabled="item.selected1==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                    <div class="prepare-content">
                      <p v-html="item.commentContent"></p>
                    </div>
                  </div>
                  <a-avatar class="avatar" slot="avatar"
                            :src="item.photo!=null?$userINfoBasePath+'/'+item.photo:'@/assets/imgs/teacher.png'"/>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
          <div style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
      </a-tabs>

    </div>
  </div>
</template>

<script>
// import HanIcon from '../components/Icon.vue'
import Card from '../components/card.vue'
import tsVideo from '../components/tsvideo.vue'

export default {
  name: 'TitleAnalysis',
  data() {
    return {
      loading: true,
      resBasePath: this.$resBasePath,
      resBaseVideo: this.$resBaseVideo,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      listData: [],
      listDatas: [],
      listDatas_use: [],
      indexNum: '',
      xtImg: require('../../../assets/image/tubiao1.png')
    }
  },
  components: {
    Card,
    // HanIcon,
    tsVideo
  },
  created() {

  },
  watch: {
    mlVisible() {

    }
  },
  mounted() {
    this.getRecommendList()
    // this.getRecommendLists()
    // this.getRecommendLists_use()
  },
  methods: {

    callback(key) {
      switch (key) {
        case '1':

          this.getRecommendList()
          break
        case '2':

          this.getRecommendLists()
          break
        case '3':

          this.getRecommendLists_use()
          break
      }
    },
    history() {
      this.$router.go(-1)
    },
    handleListChange(current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getRecommendList()
      this.getRecommendLists()
      this.getRecommendLists_use()
    },
    getRecommendList(index) { // 资源推荐列表
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        rangeType: '5',
        school: '',
        objectType: 1
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/chapter/getRecommendChapter',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listData = res.resultData.list.map((item, index) => ({...item, index}))
          this.listData.forEach(item => {
            item['selected'] = true
            if (item.index == index) {
              item['selected'] = false
            }
          })
          this.total = res.resultData.total
        }
      })
    },
    getRecommendLists(index) { // 资源推荐列表
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        rangeType: '5',
        school: '',
        objectType: 5
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/chapter/getRecommendChapter',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listDatas = res.resultData.list.map((item, index) => ({...item, index}))
          this.listDatas.forEach(item => {
            item['selected2'] = true
            if (item.index == index) {
              item['selected2'] = false
            }
          })
          this.total = res.resultData.total
        }
      })
    },
    getRecommendLists_use(index) { // 资源推荐列表
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        rangeType: '5',
        school: '',
        objectType: 3
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/chapter/getRecommendChapter',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listDatas_use = res.resultData.list.map((item, index) => ({...item, index}))
          this.listDatas_use.forEach(item => {
            item['selected1'] = true
            if (item.index == index) {
              item['selected1'] = false
            }
          })
          this.total = res.resultData.total
        }
      })
    },
    use(item) { //使用推荐资源
      this.indexNum = item.index
      const param = {
        id: item.id,
        userId: this.$getUserInfo().id
      }
      //console.log(param)
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/chapter/useOthersChapter',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('使用成功')
          this.getRecommendList(item.index)
          this.getRecommendLists(item.index)
          this.getRecommendLists_use(item.index)
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>
.sysRec {
  color: @primary-color;
  font-size: 14px;
  margin-right: 10px;
}

.main {
  // height: 110px;
 // background-color: #f0f1f5;
  width: 100%;
  height: 100%;
  margin-left: -105px;


  .breadcrumb {
    width: 1240px;
    margin: 0 auto;
  }


  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .top {
    height: 50px;
    background-color: #fff;
    position: relative;
    width: 1240px;
    margin: 0 auto;

    .goHistory {
      width: 8px;
      height: 16px;
      cursor: pointer;
    }

    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 50px;
    }

    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 70px;
      color: #9d9292;
      font-size: 18px;
    }
  }

  .content {
    // max-height: 600px;
    // min-height: 1200px;
    // background: #fff;
    width: 1240px;
    margin: 20px auto;
    height: calc(100vh - 100px);


    .list {
      overflow-y: auto;
      height: calc(100vh - 300px);
    }

    .item {
      background: #F1F0F0;
      border-radius: 6px;
      padding: 20px;
      margin: 20px;
    }

    .name,
    .class-name,
    .useNum,
    .useTo {
      letter-spacing: 0px;
      color: #9d9292;
      font-size: 14px;

      img {
        width: 40px;
        height: auto;
      }
    }

    .class-name {
      margin-left: 10px;
    }

    .xt-Img {
      width: 32px;
      height: auto;
    }

    .useTo {
      display: inline-block;
      width: 80px;
      height: 30px;
      background-color: @primary-color;
      color: #fff;
      margin-left: 20px;
    }

    .avatar {
      width: 25px;
      height: 25px;
    }

    .contentMes {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #040506;
      word-break: break-all;
    }

    .ulList {
      margin-top: 10px;

      .listMes {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #9d9292;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}

/deep/ .ant-list-pagination {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-something-after-last-item
.ant-spin-container
> .ant-list-items
> .ant-list-item:last-child {
  border-bottom: 10px solid #f1f0f0;
}

.prepare-content {
  margin-top: 15px;
  width: 100%;
  height: 100%;
  //background-color: white;
  border-radius: @border-radius-base;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #040506;
  white-space: pre-wrap;
  font-weight: normal;
  font-stretch: normal;
}

/deep/ .ant-carousel {
  width: 900px;
  height: 100%;
  margin: 0 auto;
}

/deep/ .ant-carousel .slick-slide {
  text-align: center;
  height: 80%;
  //   line-height: 300px;
  overflow: hidden;
}

/deep/ .ant-carousel .slick-slide h3 {
  color: #fff;
}

/deep/ .ant-carousel .slick-dots li button {
  background: @primary-color;
}

/deep/ .ant-list-split .ant-list-item {
  // border-bottom: 10px solid #f1f0f0;
  padding: 20px 30px 20px 30px;
  border-radius: 10px;
  background: #FFFFFF;
  margin-bottom: 10px;
}

/deep/ .ant-tabs-nav-scroll {
  border-bottom: 2px solid #F1F0F0;
}

/deep/ .ant-list-empty-text {
  background: #FFFFFF;
  border-radius: 10px;
}

/deep/ .ant-tabs {
  background: #FFFFFF;
  border-radius: 10px;
}

</style>
